import { NgClass, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MatIcon } from '@angular/material/icon';

export enum InfoBadgeColors {
  Blue,
  Green,
  Red,
  Orange,
  Black,
}

@Component({
  selector: 'shared-info-badge',
  standalone: true,
  imports: [MatIcon, NgOptimizedImage, NgClass],
  templateUrl: './info-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBadgeComponent {
  text = input.required<string>();
  fontSize = input<string>('text-xs');
  color = input<InfoBadgeColors>(InfoBadgeColors.Blue);
  textColor = input<string | null>(null);
  withBorder = input<boolean>(false);
  withIcon = input<boolean>(false);
  rounded = input<boolean>(true);

  iconType = input<'img' | 'mat-icon'>();
  icon = input<string | null>(null);

  protected readonly colors = InfoBadgeColors;

  protected getColorClasses(): string {
    const colorMap: Record<InfoBadgeColors, string> = this.textColor()
      ? {
          [InfoBadgeColors.Blue]: 'bg-info-50 border-info-600 ' + this.textColor(),
          [InfoBadgeColors.Green]: 'bg-green-mid border-green-success ' + this.textColor(),
          [InfoBadgeColors.Red]: 'bg-red-light border-red-error-dark ' + this.textColor(),
          [InfoBadgeColors.Orange]: 'bg-warning-50 border-warning-600 ' + this.textColor(),
          [InfoBadgeColors.Black]: 'bg-gray-3 border-gray-5 ' + this.textColor(),
        }
      : {
          [InfoBadgeColors.Blue]: 'bg-info-50 text-info-600',
          [InfoBadgeColors.Green]: 'bg-green-mid text-green-success',
          [InfoBadgeColors.Red]: 'bg-red-light text-red-error-dark',
          [InfoBadgeColors.Orange]: 'bg-warning-50 text-warning-600',
          [InfoBadgeColors.Black]: 'bg-gray-3 text-gray-5',
        };

    return colorMap[this.color()] || '';
  }
}
